export const quickInterviewStatusDetails = {
  A: {
    code: 'A',
    color: 'red',
    dark: true,
    description: 'Stalled',
  },
  C: {
    code: 'C',
    color: 'teal',
    dark: true,
    description: 'Closed',
  },
  F: {
    code: 'F',
    color: 'green',
    dark: true,
    description: 'Finished',
  },
  R: {
    code: 'R',
    color: 'yellow',
    dark: false,
    description: 'Ongoing',
  },
  S: {
    code: 'S',
    color: 'orange',
    dark: false,
    description: 'Started',
  },
}

export const defaultQuickInterviewState = {
  id: null,
  initial_party_data: {},
  last_step_title: '',
  last_step_index: 0,
  party_id: null,
  status: null,
  status_date: null,
  steps_data: [],
  updated_party_data: {},
  user_id: null,
}

export const QuickInterviewState = _ => ({
  quickInterview: { ...defaultQuickInterviewState },
  quickInterviewsList: [],
  quickInterviewsSteps: [],
})
